class ViewSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleViewToggle = this.handleViewToggle.bind(this)

    this.els.toggle.elements.forEach((toggleEl) => {
      this.listeners.add(toggleEl, 'click', this.handleViewToggle)
    })
  }

  async handleViewToggle (e) {
    const viewTriggerEl = e.target.closest('[data-view-switch-el="toggle"]')

    if (!viewTriggerEl) return

    const switchType = viewTriggerEl.dataset.switchType
    const currentView =
      switchType === 'mobile'
        ? this.dataset.mobileView
        : this.dataset.imageView
    const newView = viewTriggerEl.dataset.view

    if (currentView === newView) return

    this.setAttribute(`data-${switchType}-view`, newView)

    this.externalEls.grid.element.classList.replace(
      `clc-ProductGrid-${switchType}${currentView}`,
      `clc-ProductGrid-${switchType}${newView}`,
    )

    this.setButtonStates(switchType, newView)

    if (switchType === 'image') {
      await window.BAO.Cart.updateCartAttributes({
        image_view: newView,
      })
    } else {
      await window.BAO.Cart.updateCartAttributes({
        mobile_view: newView,
      })
    }
  }

  setButtonStates (switchType, newView) {
    this.els.toggle.elements.forEach((toggleEl) => {
      if (toggleEl.dataset.switchType === switchType) {
        toggleEl.setAttribute(
          'aria-pressed',
          toggleEl.dataset.view === newView,
        )
      }
    })
  }
}

if (!customElements.get('view-switch')) {
  customElements.define('view-switch', ViewSwitch)
}
